import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M7.97 4.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L12.69 10 7.97 5.28a.75.75 0 0 1 0-1.06Z" }) }), i = s.forwardRef(a);
export {
  i as F
};
//# sourceMappingURL=ChevronRight20.XQ503sZW.js.map
